import { GuestFormProps } from "@models/shared/shared.model";

const GuestForm = ({
  emailError,
  fields,
  guestFormData,
  setGuestFormData,
}: GuestFormProps) => {
  return fields.map(item => (
    <div className="form-floating mb-3" key={item.name}>
      <input
        type={item.type}
        className="form-control"
        id={`fg-booking-add-guest-${item.name}`}
        placeholder={item.labelName}
        name={item.name}
        value={guestFormData[item.name] || ""}
        onChange={e =>
          setGuestFormData(prev => ({
            ...prev,
            [item.name]: e.target.value,
          }))
        }
        maxLength={item.maxLength}
      />
      <label htmlFor={`fg-booking-add-guest-${item.name}`}>
        {item.labelName}
      </label>

      {item.name === "email" && emailError && (
        <div className="text-danger text-start small mt-1">{emailError}</div>
      )}
    </div>
  ));
};

export default GuestForm;
